import { render } from "./UserProfileInfo.vue?vue&type=template&id=70ad3bdf&scoped=true&ts=true"
import script from "./UserProfileInfo.vue?vue&type=script&lang=ts"
export * from "./UserProfileInfo.vue?vue&type=script&lang=ts"

import "./UserProfileInfo.vue?vue&type=style&index=0&id=70ad3bdf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ad3bdf"]])

export default __exports__